/**
 * Do not edit directly
 */


module.exports = {
  "colorCoreBlack": "#000",
  "colorCoreTransparent": "transparent",
  "colorCoreWhite": "#fff",
  "colorCoreBlue5": "#f2f8fd",
  "colorCoreBlue10": "#e6f1fc",
  "colorCoreBlue20": "#cce3f8",
  "colorCoreBlue30": "#b3d4f5",
  "colorCoreBlue40": "#99c6f1",
  "colorCoreBlue50": "#80b8ee",
  "colorCoreBlue60": "#66aaea",
  "colorCoreBlue70": "#4d9ce7",
  "colorCoreBlue80": "#338de3",
  "colorCoreBlue90": "#1a7fe0",
  "colorCoreBlue100": "#0071dc",
  "colorCoreBlue110": "#0066c6",
  "colorCoreBlue120": "#005ab0",
  "colorCoreBlue130": "#004f9a",
  "colorCoreBlue140": "#004484",
  "colorCoreBlue150": "#00396e",
  "colorCoreBlue160": "#002d58",
  "colorCoreBlue170": "#002242",
  "colorCoreBlue180": "#00172c",
  "colorCoreGray5": "#f8f8f8",
  "colorCoreGray10": "#f1f1f2",
  "colorCoreGray20": "#e3e4e5",
  "colorCoreGray30": "#d5d6d8",
  "colorCoreGray40": "#c7c8cb",
  "colorCoreGray50": "#babbbe",
  "colorCoreGray60": "#acadb0",
  "colorCoreGray70": "#9e9fa3",
  "colorCoreGray80": "#909196",
  "colorCoreGray90": "#828489",
  "colorCoreGray100": "#74767c",
  "colorCoreGray110": "#686a70",
  "colorCoreGray120": "#5d5e63",
  "colorCoreGray130": "#515357",
  "colorCoreGray140": "#46474a",
  "colorCoreGray150": "#3a3b3e",
  "colorCoreGray160": "#2e2f32",
  "colorCoreGray170": "#232325",
  "colorCoreGray180": "#171819",
  "colorCoreGreen5": "#f4f9f2",
  "colorCoreGreen10": "#eaf3e6",
  "colorCoreGreen20": "#d4e7cd",
  "colorCoreGreen30": "#bfdbb3",
  "colorCoreGreen40": "#aacf9a",
  "colorCoreGreen50": "#95c381",
  "colorCoreGreen60": "#7fb768",
  "colorCoreGreen70": "#6aab4f",
  "colorCoreGreen80": "#559f35",
  "colorCoreGreen90": "#3f931c",
  "colorCoreGreen100": "#2a8703",
  "colorCoreGreen110": "#267a03",
  "colorCoreGreen120": "#226c02",
  "colorCoreGreen130": "#1d5f02",
  "colorCoreGreen140": "#195102",
  "colorCoreGreen150": "#154402",
  "colorCoreGreen160": "#113601",
  "colorCoreGreen170": "#0d2901",
  "colorCoreGreen180": "#081b01",
  "colorCoreOrange5": "#fff7f2",
  "colorCoreOrange10": "#fff0e6",
  "colorCoreOrange20": "#fee0cc",
  "colorCoreOrange30": "#fed1b3",
  "colorCoreOrange40": "#fdc199",
  "colorCoreOrange50": "#fdb280",
  "colorCoreOrange60": "#fca266",
  "colorCoreOrange70": "#fc934d",
  "colorCoreOrange80": "#fb8333",
  "colorCoreOrange90": "#fb741a",
  "colorCoreOrange100": "#fa6400",
  "colorCoreOrange110": "#e15300",
  "colorCoreOrange120": "#c83c00",
  "colorCoreOrange130": "#af2f00",
  "colorCoreOrange140": "#962300",
  "colorCoreOrange150": "#7d1900",
  "colorCoreOrange160": "#641100",
  "colorCoreOrange170": "#4b0a00",
  "colorCoreOrange180": "#320500",
  "colorCorePink5": "#fcf4f9",
  "colorCorePink10": "#faeaf4",
  "colorCorePink20": "#f5d5e9",
  "colorCorePink30": "#efc0de",
  "colorCorePink40": "#eaabd3",
  "colorCorePink50": "#e596c8",
  "colorCorePink60": "#e080bc",
  "colorCorePink70": "#db6bb1",
  "colorCorePink80": "#d556a6",
  "colorCorePink90": "#d0419b",
  "colorCorePink100": "#cb2c90",
  "colorCorePink110": "#b72882",
  "colorCorePink120": "#a22373",
  "colorCorePink130": "#8e1f65",
  "colorCorePink140": "#7a1a56",
  "colorCorePink150": "#661648",
  "colorCorePink160": "#51123a",
  "colorCorePink170": "#3d0d2b",
  "colorCorePink180": "#29091d",
  "colorCorePurple5": "#f7f5f9",
  "colorCorePurple10": "#efebf2",
  "colorCorePurple20": "#e0d6e5",
  "colorCorePurple30": "#d0c2d8",
  "colorCorePurple40": "#c1adcb",
  "colorCorePurple50": "#b199bf",
  "colorCorePurple60": "#a184b2",
  "colorCorePurple70": "#9270a5",
  "colorCorePurple80": "#825b98",
  "colorCorePurple90": "#73478b",
  "colorCorePurple100": "#63327e",
  "colorCorePurple110": "#592d71",
  "colorCorePurple120": "#4f2865",
  "colorCorePurple130": "#452358",
  "colorCorePurple140": "#3b1e4c",
  "colorCorePurple150": "#32193f",
  "colorCorePurple160": "#281432",
  "colorCorePurple170": "#1e0f26",
  "colorCorePurple180": "#140a19",
  "colorCoreRed5": "#fdf4f4",
  "colorCoreRed10": "#fce8e9",
  "colorCoreRed20": "#f8d2d3",
  "colorCoreRed30": "#f5bbbd",
  "colorCoreRed40": "#f2a4a7",
  "colorCoreRed50": "#ef8e92",
  "colorCoreRed60": "#eb777c",
  "colorCoreRed70": "#e86066",
  "colorCoreRed80": "#e54950",
  "colorCoreRed90": "#e1333a",
  "colorCoreRed100": "#de1c24",
  "colorCoreRed110": "#c81920",
  "colorCoreRed120": "#b2161d",
  "colorCoreRed130": "#9b1419",
  "colorCoreRed140": "#851116",
  "colorCoreRed150": "#6f0e12",
  "colorCoreRed160": "#590b0e",
  "colorCoreRed170": "#43080b",
  "colorCoreRed180": "#2c0607",
  "colorCoreSpark5": "#fffcf4",
  "colorCoreSpark10": "#fff9e9",
  "colorCoreSpark20": "#fff3d2",
  "colorCoreSpark30": "#ffedbc",
  "colorCoreSpark40": "#ffe7a6",
  "colorCoreSpark50": "#ffe190",
  "colorCoreSpark60": "#ffda79",
  "colorCoreSpark70": "#ffd463",
  "colorCoreSpark80": "#ffce4d",
  "colorCoreSpark90": "#ffc836",
  "colorCoreSpark100": "#ffc220",
  "colorCoreSpark110": "#e6a31d",
  "colorCoreSpark120": "#cc851a",
  "colorCoreSpark130": "#b36a16",
  "colorCoreSpark140": "#995213",
  "colorCoreSpark150": "#803d10",
  "colorCoreSpark160": "#662b0d",
  "colorCoreSpark170": "#4d1c0a",
  "colorCoreSpark180": "#330f06",
  "colorCoreYellow5": "#fffef2",
  "colorCoreYellow10": "#fffee6",
  "colorCoreYellow20": "#fffccc",
  "colorCoreYellow30": "#fffbb3",
  "colorCoreYellow40": "#fffa99",
  "colorCoreYellow50": "#fff980",
  "colorCoreYellow60": "#fff766",
  "colorCoreYellow70": "#fff64d",
  "colorCoreYellow80": "#fff533",
  "colorCoreYellow90": "#fff31a",
  "colorCoreYellow100": "#fff200",
  "colorCoreYellow110": "#e6cb00",
  "colorCoreYellow120": "#cca700",
  "colorCoreYellow130": "#b38600",
  "colorCoreYellow140": "#996900",
  "colorCoreYellow150": "#804f00",
  "colorCoreYellow160": "#663800",
  "colorCoreYellow170": "#4d2500",
  "colorCoreYellow180": "#331500",
  "colorPositiveMin": "#eaf3e6",
  "colorPositiveLow": "#95c381",
  "colorPositiveBase": "#2a8703",
  "colorPositiveHigh": "#1d5f02",
  "colorPositiveMax": "#113601",
  "colorPrimaryMin": "#e6f1fc",
  "colorPrimaryLow": "#80b8ee",
  "colorPrimaryBase": "#0071dc",
  "colorPrimaryHigh": "#004f9a",
  "colorPrimaryMax": "#002d58",
  "colorNegativeMin": "#fce8e9",
  "colorNegativeLow": "#ef8e92",
  "colorNegativeBase": "#de1c24",
  "colorNegativeHigh": "#9b1419",
  "colorNegativeMax": "#590b0e",
  "colorWarningMin": "#fff9e9",
  "colorWarningLow": "#ffe190",
  "colorWarningBase": "#ffc220",
  "colorWarningHigh": "#b36a16",
  "colorWarningMax": "#662b0d",
  "colorSeparator100": "#e3e4e5",
  "borderRadius0": "0",
  "borderRadius25": "0.1875rem",
  "borderRadius50": "0.375rem",
  "borderRadius100": "0.75rem",
  "borderRadius200": "1.5rem",
  "borderRadiusRound": "93.75rem",
  "duration100": 100,
  "duration200": 200,
  "duration300": 300,
  "duration400": 400,
  "duration500": 500,
  "duration600": 600,
  "duration700": 700,
  /**
   * @deprecated 0.9s is not defined in motion specifications, so the token will be removed in the future.
   */
  "duration900": 900,
  "elevation100": "0 0.0625rem 0.125rem 0.0625rem rgba(0, 0, 0, 0.15), 0 -0.0625rem 0.125rem 0 rgba(0, 0, 0, 0.10)",
  "elevation200": "0 0.1875rem 0.3125rem 0.125rem rgba(0, 0, 0, 0.15), 0 -0.0625rem 0.1875rem 0 rgba(0, 0, 0, 0.10)",
  "elevation300": "0 0.3125rem 0.625rem 0.1875rem rgba(0, 0, 0, 0.15), 0 -0.0625rem 0.25rem 0 rgba(0, 0, 0, 0.10)",
  "fontFamilyDefault": "Bogle, 'Helvetica Neue', Helvetica, Arial, sans-serif",
  "fontFamilyMonospace": "BogleMono, monospace",
  /**
   * @deprecated Deprecated for non-px numeric scale. Update to `font.size.25`
   */
  "fontSize12": "0.75rem",
  /**
   * @deprecated Deprecated for non-px numeric scale. Update to `font.size.50`
   */
  "fontSize14": "0.875rem",
  /**
   * @deprecated Deprecated for non-px numeric scale. Update to `font.size.100`
   */
  "fontSize16": "1rem",
  /**
   * @deprecated Deprecated for non-px numeric scale. Update to `font.size.150`
   */
  "fontSize18": "1.125rem",
  /**
   * @deprecated Deprecated for non-px numeric scale. Update to `font.size.200`
   */
  "fontSize20": "1.25rem",
  /**
   * @deprecated Deprecated for non-px numeric scale. Update to `font.size.300`
   */
  "fontSize24": "1.5rem",
  "fontSize25": "1.125rem",
  /**
   * @deprecated Deprecated for non-px numeric scale. Update to `font.size.400`
   */
  "fontSize28": "1.75rem",
  /**
   * @deprecated Deprecated for non-px numeric scale. Update to `font.size.500`
   */
  "fontSize32": "2rem",
  /**
   * @deprecated Deprecated for non-px numeric scale. Update to `font.size.600`
   */
  "fontSize36": "2.25rem",
  /**
   * @deprecated Deprecated for non-px numeric scale. Update to `font.size.700`
   */
  "fontSize42": "2.625rem",
  "fontSize50": "1.3125rem",
  "fontSize100": "1.5rem",
  "fontSize150": "1.6875rem",
  "fontSize200": "1.875rem",
  "fontSize300": "2.25rem",
  "fontSize400": "2.625rem",
  "fontSize500": "3rem",
  "fontSize600": "3.375rem",
  "fontSize700": "3.9375rem",
  "fontWeight400": 400, // normal
  "fontWeight700": 700, // bold
  "sizeBreakpointSmall": "0",
  "sizeBreakpointMedium": "37.5rem",
  "sizeBreakpointLarge": "56.25rem",
  "sizeBreakpointXlarge": "75rem",
  "sizeBreakpointXxlarge": "120rem",
  "sizeIconSmall": "1.5rem",
  "sizeIconMedium": "2.25rem",
  "sizeIconLarge": "3rem",
  "sizeSpace50": "0.375rem",
  "sizeSpace100": "0.75rem",
  "sizeSpace150": "1.125rem",
  "sizeSpace200": "1.5rem",
  "sizeSpace250": "1.875rem",
  "sizeSpace300": "2.25rem",
  "sizeSpace400": "3rem",
  "sizeSpace500": "3.75rem",
  "sizeSpace600": "4.5rem",
  "timingEaseIn100": "cubic-bezier(0.55, 0.055, 0.675, 0.19)",
  "timingEaseInOut100": "cubic-bezier(0.77, 0, 0.175, 1)",
  "timingEaseOut100": "cubic-bezier(0.165, 0.84, 0.44, 1)",
  "timingLinear100": "linear",
  "zIndex100": "100",
  "zIndex200": "200",
  "zIndex300": "300",
  "zIndex400": "400",
  "zIndex500": "500",
  "zIndex600": "600",
};